import { httpClient } from 'api';
import { AdminApplicationNote, AdminPairNote } from 'types/AdminNote';

export const adminNotesApi = {
	getAdminNotes: (applicationId: number, programId: number) =>
		httpClient.get<AdminApplicationNote[]>(`/admin-notes/${programId}/application/${applicationId}`),
	addAdminNote: (applicationId: number, content: string, programId: number) =>
		httpClient.post<AdminApplicationNote>(`/admin-notes/${programId}/application/${applicationId}`, { content }),
	deleteAdminNote: (noteId: number, programId: number) =>
		httpClient.delete<void>(`/admin-notes/${programId}/application/${noteId}`),
	getPairAdminNotes: (pairId: number, programId: number) =>
		httpClient.get<AdminPairNote[]>(`/admin-notes/${programId}/pair/${pairId}`),
	addPairAdminNote: (pairId: number, content: string, programId: number) =>
		httpClient.post<AdminPairNote>(`/admin-notes/${programId}/pair/${pairId}`, { content }),
	deletePairAdminNote: (noteId: number, programId: number) =>
		httpClient.delete<void>(`/admin-notes/${programId}/pair/${noteId}`),
};
